// extracted by mini-css-extract-plugin
module.exports = {"loader":"src-components-ui-Spinner-styles__loader"};